<div class="container-fluid pattern ">
  <div class="row" style="padding-top:30px;text-align: center;">

        <div class="col-md-3" data-aos="fade-left"
             data-aos-offset="100"
             data-aos-easing="ease-in-sine">

          <div class="container animated zoomIn">
            <div class="row">
             <div class="animation"></div>
            </div>
          </div>

        </div>
        <div class="col-md-6" data-aos="zoom-in">
          <h1>
            <a  class="typewrite" data-period="1000"
               data-type='[ "Hi, I am BENDRIMOU Ayoub.", "I am Full-Stack Developer.",
               "I Love HTML5, JS, CSS3 and Bootstrap.","I Love to Develop.",
               "I Love to Code."]'>

              <span class="wrap"></span>
            </a>
          </h1>

          <img id="imga" src="./assets/images5/logo.png" alt="profile image" height="160px" >
          <br>
          <h6>
            Lorem Loerem Lorem LoeremLorem LoeremLorem LoeremLorem LoeremLorem Loerem
            Lorem LoeremLorem LoeremLorem<br> LoeremLorem LoeremLorem LoeremLorem LoeremLorem LoeremLorem Loerem
            Lorem LoeremLorem LoeremLorem LoeremLorem Loerem
            Lorem Loerem

          </h6>
          <br>
<div class="row" >
  <div class="col-md-4"> </div>
  <div class="col-md-1" ><a href="#" >               <img src="./assets/images5/facebook.png" alt="">
  </a> </div>
  <div class="col-md-1" > <a href="#" > <img src="./assets/images5/twitter.png" alt=""> </a>    </div>
  <div class="col-md-1"> <a href="#" > <img src="./assets/images5/linkedin.png" alt=""> </a>  </div>
  <div class="col-md-1"> <a href="#" > <img src="./assets/images5/linkedin.png" alt="">  </a> </div>
  <div class="col-md-4" ></div>


</div>
          <br>
<div class="bar"></div>
          <br>
            <nav class="fill">
              <ul>
                <li><a href="#">About</a></li>
                <li><a href="#">My Work</a></li>
                <li><a href="#">Skills</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="#">Hire Me</a></li>
              </ul>
            </nav>


        </div>
        <div class="col-md-3" data-aos="fade-right"
             data-aos-offset="300"
             data-aos-easing="ease-in-sine">

          <div class="container animated zoomIn">
            <div class="row">
              <div class="animation1"></div>
            </div>
          </div>
        </div>
      </div>


    </div>



